import { Heading, Text } from "@chakra-ui/react"
import { brands, searchNavigationParams } from "../../../../common/constants/constants"
import { useBrandedTranslation } from "../../../../common/hooks/useBrandedTranslation"
import { useQueryParam } from "../../../../common/lib/QueryParamContext"

type Props = {
  searchTerm: string
  numberOfItems: number
}

const ResultsCountInfo = ({ searchTerm, numberOfItems }: Props) => {
  const { t } = useBrandedTranslation()
  const { queryParam } = useQueryParam()
  const isSeries = queryParam.name === searchNavigationParams.SERIES
  const isSparePartsAll = queryParam.name === searchNavigationParams.ALL_SPARE_PARTS

  const displaySearchTerm =
    queryParam.name === searchNavigationParams.NEW
      ? t("nav-newReleases")
      : queryParam.name === searchNavigationParams.CROSS
      ? t("search-cross-selling-page-title", { brandName: brands[queryParam.value]?.name })
      : queryParam.name === searchNavigationParams.MIX_AND_MATCH
      ? t("mix-and-match-page-title")
      : isSeries
      ? t("series-products-title")
      : isSparePartsAll
      ? t("nav-spareParts")
      : searchTerm
  const showNumberOfResults =
    queryParam.name === searchNavigationParams.SEARCH_TERM ||
    queryParam.name === searchNavigationParams.CHARACTERISTICS ||
    queryParam.name === searchNavigationParams.APPLICATION_PURPOSES

  return (
    <Heading
      as={`${isSeries ? "h2" : "h1"}`}
      fontSize={{ base: "4xl", sm: "5xl", md: "6xl" }}
      fontWeight="light"
      letterSpacing="0"
      lineHeight={{ base: "8", sm: "9", md: "10" }}
      mb={{ base: "6", md: "8" }}
    >
      {showNumberOfResults && (
        <Text as="span">
          {numberOfItems} {t("search-results-for", { count: numberOfItems })}{" "}
        </Text>
      )}
      <Text as="span" fontWeight="bold">
        {displaySearchTerm}
      </Text>
    </Heading>
  )
}

export default ResultsCountInfo
